export default __webpack_public_path__ + "static/coctail-04-cf8d326a3332a31dbbe302e53130ea78.png";